/**
 * @file
 * Component that purifies and renders cutline text passed in from Drupal.
 */

import dompurify from 'dompurify';
import * as React from 'react';

// Config
import { DEFAULT_CUTLINE_MESSAGE } from '../../config';

interface IProps {
  text: string;
}

const CutlineText = ({ text }: IProps) => {
  return (
    <span data-testid="cutline-text">
      {text ? (
        <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(text) }} />
      ) : (
        DEFAULT_CUTLINE_MESSAGE
      )}
    </span>
  );
};

export default CutlineText;
